import { useEffect, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  betStore,
  userInfoStore,
  roundInfoStore,
  gameConfigStore,
  notificationStore,
} from '@pascal/pascal-core/shared/core/store';
import {
  NumPad,
  isMobile,
  useTranslation,
  useClickOutside,
  applicationStore,
  useInputValueChangingFunctions,
} from '@pascal/pascal-core';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { InputTypesForChanging } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { gameStore } from '../../../store/gameStore';
import NumpadWrapper from '../../mobile/numpadWrapper';
import { doBetStore } from '../../../store/doBetStore';
import { marketsStore } from '../../../store/marketsStore';
import { betAmountValidator } from '../../../helpers/supporters';

let mobileWrRef;

export const BetBlock = observer(({ innerComp: InnerComp }) => {
  const t = useTranslation();
  const { limits } = gameConfigStore;
  const { isDemo } = applicationStore;
  const { repliedBetData } = betStore;
  const { roundId } = roundInfoStore;
  const { gameTypeId } = gameConfigStore;
  const { replayData = null } = repliedBetData || {};
  const { currencyCode, precision } = userInfoStore;
  const { activeButton, selectedMarket } = marketsStore;
  const { partnerWageringOdd } = gameStore;
  const { isOpen } = gameStore.numPadData;
  const {
    betData: { amount },
    reBetData,
    totalBetsAmount,
    isLoadingBetButton,
    isLoadingReBetButton,
  } = doBetStore;
  const [namPudInputValue, updateNumPudInputValue] = useState(
    limits?.defaultBetAmount || limits.minBet
  );
  const [isValidatedAmount, setIsValidatedAmount] = useState(false);

  const [ref, hasClickedOutside] = useClickOutside();
  const { handleChangeInputValue } = useInputValueChangingFunctions({
    dividerOrMultiplayer: 2,
    changingValue: amount,
    changingValueCallback: doBetStore.setBetAmount,
    additionalInputInfo: { inputType: InputTypesForChanging.BetInput },
  });

  const decidedCallBackCall = (callback) => {
    if (isValidatedAmount) {
      setIsValidatedAmount(false);
    } else {
      callback();
    }
  };

  const { activeFreeBet } = freeBetStore;

  useEffect(() => {
    if (Object.keys(activeFreeBet)?.length) {
      doBetStore.setBetAmount(activeFreeBet?.amount);
    } else {
      doBetStore.setBetAmount(limits?.defaultBetAmount || limits.minBet);
    }
  }, [activeFreeBet]);

  // useEffect(() => {
  //   if (reBetData.length) {
  //     const reBetFreeBet = reBetData?.filter((item) => item.freeBetId);
  //
  //     if (activeFreeBet.id && !reBetFreeBet.length) {
  //       updatedReBetData();
  //     }
  //
  //     if (!activeFreeBet.id && reBetFreeBet.length) {
  //       updatedReBetData();
  //     }
  //
  //     if (reBetFreeBet.length !== reBetData.length) {
  //       if (reBetFreeBet.length) {
  //         updatedReBetData();
  //       }
  //     } else {
  //       if (activeFreeBet.id && activeFreeBet.remainingCount < reBetData.length) {
  //         updatedReBetData();
  //       }
  //     }
  //   }
  // }, [reBetData.length, activeFreeBet, isBetsClosed]);

  useLayoutEffect(() => {
    mobileWrRef = document.querySelector('.mobile-wr');
  }, []);

  useEffect(() => {
    if (hasClickedOutside) {
      gameStore.setNumPadData({ isOpen: false, currentInputValue: null });
    }
  }, [hasClickedOutside]);

  const validatedNumPudInputValue = (callback) => {
    const { validatedBetAmount, errorMessageCode } = betAmountValidator(namPudInputValue, limits);
    if (errorMessageCode) {
      notificationStore.setNotificationType({ responseCode: errorMessageCode });
    }
    // iframeService.sendStakeUpdate(validatedBetAmount);
    callback(validatedBetAmount);
  };

  const handleSubmit = (isConfirmed) => {
    if (isConfirmed) {
      validatedNumPudInputValue(doBetStore.setBetAmount);
      gameStore.setNumPadData({ isOpen: false, sectionName: null, currentInputValue: null });
    }
  };

  const handleOpenNumPad = (event) => {
    if (isMobile()) {
      updateNumPudInputValue(event.target.value);
      gameStore.setNumPadData({
        isOpen: true,
        currentInputValue: event.target.value,
      });
    }
  };

  return (
    <>
      <InnerComp
        t={t}
        isDemo={isDemo}
        limits={limits}
        roundId={roundId}
        betAmount={amount}
        reBetData={reBetData}
        precision={precision}
        gameTypeId={gameTypeId}
        replayData={replayData}
        currencyCode={currencyCode}
        activeButton={activeButton}
        setBetAmount={doBetStore.setBetAmount}
        onBetClick={doBetStore.doBetSender}
        activeFreeBet={activeFreeBet}
        onInputClick={handleOpenNumPad}
        decidedCallBackCall={decidedCallBackCall}
        selectedMarket={selectedMarket}
        totalBetsAmount={totalBetsAmount}
        isLoadingBetButton={isLoadingBetButton}
        partnerWageringOdd={partnerWageringOdd}
        isLoadingReBetButton={isLoadingReBetButton}
        setIsValidatedAmount={setIsValidatedAmount}
        handleChangeAmount={handleChangeInputValue}
      />
      {isOpen && !activeFreeBet.id && (
        <NumpadWrapper containerRef={mobileWrRef}>
          <div ref={ref} className='numpad-wr-for-outside-click'>
            <NumPad
              t={t}
              limits={limits}
              isOpen={isOpen}
              precision={precision}
              onSubmit={handleSubmit}
              amountValue={namPudInputValue}
              setAmountValue={updateNumPudInputValue}
            />
          </div>
        </NumpadWrapper>
      )}
    </>
  );
});
